import { render, staticRenderFns } from "./SocialWorkSkillsSheet.vue?vue&type=template&id=0b286134"
import script from "./SocialWorkSkillsSheet.vue?vue&type=script&lang=js"
export * from "./SocialWorkSkillsSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports